import * as React from 'react';
import { IPaginationOptions } from './pagination';

export interface IPagingSelectProps {
    paging: IPaginationOptions;
    onPageSelect(page: number): void;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
    value: number;
    id: string;
    labelText?: string;
    pagingButtonText?: string;
}



/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingSelect extends React.Component<IPagingSelectProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            value: 1,
            error: false,
            errorText: `Page does not exist`
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({ error: false });
        let targetNumber = parseInt(event.target.value);
        if (targetNumber <= this.props.paging.totalPages && targetNumber != null && targetNumber != NaN && targetNumber >= 1) {
            this.setState({ value: targetNumber });
        }
        else {
            this.setState({ value: event.target.value });
            this.setState({ error: true });
        }
    }

    handleSubmit(event) {
        if (this.state.value != null && this.state.value <= this.props.paging.totalPages && this.state.value >= 1){
            this.props.onPageSelect(this.state.value);
        }
        event.preventDefault();
    }
    /// <summary>
    /// Input for page selection specific to the search pagination
    /// </summary>
    /// <returns>input and button for page selection</returns>
    GetPageSelection() {
      
        return (
                <div className="paging-select-wrapper paging-select-search">
                <form onSubmit={this.handleSubmit} className={"paging-select-form"}>
                    <label className="form-element-label" htmlFor={this.props.id}>
                        <span className="form-element-label-main">Go to page</span>
                    </label>
                    <input className="paging-select-form-input"
                        type={'number'}
                        id={this.props.id}
                        value={this.state.value}
                        onChange={this.handleChange}
                        placeholder={null}
                        required={false}
                />
                
               <input className="button-secondary paging-select-button" type="submit" value="Go" />
            </form>
           {this.state.error &&
                    <div className="paging-select-error"><svg>
                        <use xlinkHref="#icon-error"></use>
                    </svg> {this.state.errorText}</div>
            } 
            </div>
            );
    }

    render() {
        return this.GetPageSelection();
    }
}